import React, { PureComponent } from 'react';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, number, string } from '@philips-emr/tws-core/lib/component/prop-types';

import HpmsContratosOptionsApi from '../../api/hpms-contratos-options-api';
import './hpms-contratos-options.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsContratosOptionsApi })
class HpmsContratosOptions extends PureComponent {

  static propTypes = {
    nrSeqContrato: number,
    title: string,
    subtitle: string,
    onOptionClick: eventListener,
  }

  onOption() {
    const { onOptionClick, nrSeqContrato } = this.props;

    onOptionClick && onOptionClick({ value: nrSeqContrato });
  }

  render() {
    const { title, subtitle } = this.props;
    return (
      <div className="c-hpms-contratos-options" onClick={() => this.onOption()}>
        <div className="c-text u-text-bold c-text--sm u-text-initial">{title}</div>
        <div className="c-text c-text--sm u-text-initial">{subtitle}</div>
      </div>
    );
  }
}

export default HpmsContratosOptions;
